module.exports = __webpack_public_path__ + "img/icono_novo8.00ba5ee4.svg";